import { INVITE_BRAND_VARIANTS } from './constants';

export const getInviteBrandColors = (variant, theme) =>
  ({
    [INVITE_BRAND_VARIANTS.PORTER]: {
      primary: theme.colors.porterPrimary,
      secondary: theme.colors.porterSecondary,
    },
    [INVITE_BRAND_VARIANTS.KIPER]: {
      primary: theme.colors.inviteKiperPrimary,
      secondary: theme.colors.inviteKiperSecondary,
    },
  }[variant]);
